import createReducer from '../../common/util/createReducer';
import {ActionTypes} from '../actions';

const INITIAL_STATE = {
  'loading': false,
  'loadingDetails': false,
  'loadingTracking': false,
  'list': [],
  'invoiceDetails': [],
  'invoiceTracking': [],
  'statusList': [],
  'timerRequest': true,
  'url': '',
};

export const partsImportsInvoices = (state, action) => {
  return createReducer(INITIAL_STATE, {
    [ActionTypes.FETCHING_PARTS_IMPORTS_INOVICES]: (state, action) => ({
      ...state,
      'loading': true,
      'list': [],
    }),
    [ActionTypes.FETCHED_PARTS_IMPORTS_INOVICES]: (state, action) => ({
      ...state,
      'loading': false,
      'list': action.response.data,
    }),
    [ActionTypes.FETCHED_PARTS_IMPORTS_INOVICES_FAILED]: (state, action) => ({
      ...state,
      'loading': false,
      'list': [],
    }),
    [ActionTypes.CLEAN_IMPORTS_TRACKING_INVOICES_LIST]: (state, action) => ({
      ...state,
      'list': [],
    }),
    [ActionTypes.FETCHING_PARTS_IMPORTS_INOVICE_DETAILS]: (state, action) => ({
      ...state,
      'loadingDetails': true,
      'invoiceDetails': [],
    }),
    [ActionTypes.FETCHED_PARTS_IMPORTS_INOVICE_DETAILS]: (state, action) => ({
      ...state,
      'loadingDetails': false,
      'invoiceDetails': action.response.data ? action.response.data[0].invoice_details ?
        action.response.data[0].invoice_details : [] : [],
    }),
    [ActionTypes.FETCHED_PARTS_IMPORTS_INOVICE_DETAILS_FAILED]: (state, action) => ({
      ...state,
      'loadingDetails': false,
      'invoiceDetails': [],
    }),
    [ActionTypes.FETCHING_PARTS_IMPORTS_INOVICE_TRACKING]: (state, action) => ({
      ...state,
      'loadingTracking': true,
      'invoiceTracking': [],
    }),
    [ActionTypes.FETCHED_PARTS_IMPORTS_INOVICE_TRACKING]: (state, action) => ({
      ...state,
      'loadingTracking': false,
      'invoiceTracking': action.response.data,
    }),
    [ActionTypes.FETCHED_PARTS_IMPORTS_INOVICE_TRACKING_FAILED]: (state, action) => ({
      ...state,
      'loadingTracking': false,
      'invoiceTracking': [],
    }),
    [ActionTypes.CREATING_PARTS_IMPORTS_INOVICE_TRACKING_PARTIAL]: (state, action) => ({
      ...state,
      'loadingTracking': true,
    }),
    [ActionTypes.CREATED_PARTS_IMPORTS_INOVICE_TRACKING_PARTIAL]: (state, action) => ({
      ...state,
      'loadingTracking': false,
      'invoiceTracking': action.response.data,
    }),
    [ActionTypes.CREATED_PARTS_IMPORTS_INOVICE_TRACKING_PARTIAL_FAILED]: (state, action) => ({
      ...state,
      'loadingTracking': false,
    }),
    [ActionTypes.UPDATING_PARTS_IMPORTS_INOVICE_TRACKING]: (state, action) => ({
      ...state,
      'loadingTracking': true,
    }),
    [ActionTypes.UPDATED_PARTS_IMPORTS_INOVICE_TRACKING]: (state, action) => ({
      ...state,
      'loadingTracking': false,
      'invoiceTracking': action.response.data,
    }),
    [ActionTypes.UPDATED_PARTS_IMPORTS_INOVICE_TRACKING_FAILED]: (state, action) => ({
      ...state,
      'loadingTracking': false,
    }),
    [ActionTypes.FETCHING_IMPORTS_TRACKING_STATUS_LIST]: (state, action) => ({
      ...state,
      'statusList': [],
    }),
    [ActionTypes.FETCHED_IMPORTS_TRACKING_STATUS_LIST]: (state, action) => ({
      ...state,
      'statusList': action.response.data,
    }),
    [ActionTypes.FETCHED_IMPORTS_TRACKING_STATUS_LIST_FAILED]: (state, action) => ({
      ...state,
      'statusList': [],
    }),
    [ActionTypes.SET_IMPORTS_TRACKING_TIMER]: (state, action) => ({
      ...state,
      'timerRequest': action.payload,
    }),
    [ActionTypes.EXPORTING_PARTS_IMPORTS_INOVICES]: (state, action) => ({
      ...state,
      'loading': true,
    }),
    [ActionTypes.EXPORTED_PARTS_IMPORTS_INOVICES]: (state, action) => ({
      ...state,
      'loading': false,
      'url': action.response.data,
    }),
    [ActionTypes.EXPORTED_PARTS_IMPORTS_INOVICES_FAILED]: (state, action) => ({
      ...state,
      'loading': false,
      'url': '',
    }),
    [ActionTypes.CLEAN_EXPORTED_PARTS_IMPORTS_INOVICES_URL]: (state, action) => ({
      ...state,
      'loading': false,
      'url': '',
    }),
  })(state, action);
};
